import { Component, OnInit } from "@angular/core";
import { ProductAuthResponse } from "src/app/models/productAuth";

@Component({
  selector: "app-bharat-biri-auth",
  templateUrl: "./bharat-biri-auth.component.html",
  styleUrls: ["./bharat-biri-auth.component.css"],
})
export class BharatBiriAuthComponent implements OnInit {
  prodDetails: ProductAuthResponse = new ProductAuthResponse();
  slideConfig2 = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dot: true,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: true,
    centerMode: false,
  };
  constructor() {}


  ngOnInit() {
    this.prodDetails = JSON.parse(localStorage.getItem("BharatBiriData"));
  }

  slickInit(event) {}
  breakpoint(event) {}
  afterChange(event) {}
  beforeChange(event) {}
}
